// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__LmpQX","bigColWidth":"Table_bigColWidth__17JEH","biggerColWidth":"Table_biggerColWidth__3-0Hq","row":"Table_row__1mIIT","col":"Table_col__35awG"};